import { DashboardRouter } from "../dashboard.router";

export class ActionLogsRouter {
    
    static getRoute(): string {
        return `${DashboardRouter.getRoute()}/logs`
    }

}